const OwalLabelStyle = {
  BASIC: 0,
  OUTLINE: 1,
  TAG: 2,
  properties: {
    0: { description: 'basic' },
    1: { description: 'outline' },
    2: { description: 'tag' },
  },
}

if (Object.freeze) {
  Object.freeze(OwalLabelStyle)
}

export { OwalLabelStyle }
